var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"issue-chat-history"},[_c('div',{staticClass:"issue-chat-history__status",style:({background: _vm.actionColor})},[_vm._v("\n    "+_vm._s(_vm.item.action)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }